import { WorkflowConstants } from 'constants/workflowConstants';
import { createAction } from 'redux-actions';

export const checkinAction = createAction(WorkflowConstants.CHECKIN_ACTION);
export const nextAction = createAction(WorkflowConstants.NEXT_ACTION);
export const checkPreviousAction = createAction(WorkflowConstants.PREVIOUS_ACTION);
export const getAdditionalSavingAmount = createAction(WorkflowConstants.ADDTIONAL_SAVING_AMOUNT);



// WEBPACK FOOTER //
// ./src/actions/workflow.js